var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RoundButton',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltip,
    classes: 'tooltip w-tooltip',
  }),expression:"{\n    content: tooltip,\n    classes: 'tooltip w-tooltip',\n  }"}],staticClass:"task-item-options",attrs:{"icon":"ellipsis-v"}})}
var staticRenderFns = []

export { render, staticRenderFns }